import React from 'react';
import IndexChat from '../../components/chat/Index';

export default function Home() {
  return <IndexChat />;
}
